import React, {Component} from 'react';
import './PropertySearch.scss';
import FormElement from "../FormElement/FormElement";
import Button from "../Button/Button";
import request from "../../Ajax";
import Loader from "../Loader/Loader";
import {toast} from "react-toastify";

export default class PropertySearch extends Component {

    constructor(props) {
        super(props);

        this.inner_state = {
            url: 'propertySearch',
            labels: 'getLabels',
        };

        this.state = {
            validClassName: "",
            plateNumber: this.props.dataState.plateNumber ? this.props.dataState.plateNumber : "",
            idNumber: this.props.dataState.idNumber ? this.props.dataState.idNumber : "",
            isFetching: false,
            error: false,
            labels: []
        };

        this.handleInputChange = this.handleInputChange.bind(this);
    }

    componentDidMount(){
        request(
            this.inner_state.labels,
            'post',
            { 'page_type' : 'search_auto', 'lang' : this.props.lang },
            (response) => {
                if (response.data.status === true) {
                    this.setState({ labels: response.data.data });
                } else {
                    //todo chgitem inch erb labelneri het kapvac xndir ka
                }
            }
        );
    };

    handleInputChange(e) {
        this.setState({validClassName: "valid-element", [e.target.name]: e.target.value});
    }

    error = (error_message) => {
        return error_message ?  <div className="column small-12">
            <div className="date_warning">
                <span className="custom_icon_warning">!</span>
                <span className="date_warning_text">
                    {error_message}
                            </span>
            </div>
        </div>  : ''
    };


    handleSubmit = event => {

      event.preventDefault();

      this.setState({ isFetching: true });

        request(
            this.inner_state.url,
            'post',
            this.state,
            (response) => {
                if (response.data.status === true) {
                    response.data.data['plateNumber'] = this.state.plateNumber;
                    this.props.onSubmit(response.data.data);
                    this.setState({  error: false });
                } else {
                    this.setState({ isFetching: false , error: response.data.message });
                }
            }
        );

    };

    render() {

        return (
          <>
              <div className="column small-12">
                  <div className="top_section">
                      <div className="top_section__headline custom-headline">
                          <h2>
                              {this.state.labels.title}
                            {/*ԱվտՈմեքենայի Եւ ապահովադրի որոնում*/}
                          </h2>
                      </div>
                      <div className="top_section__desc">
                          {this.state.labels.small_title}
                        {/*Խնդրում ենք մուտքագրել Ձեր մեքենայի հաշվառման համարանիշը և անձը հաստատող փաստաթղթի համարը*/}
                      </div>
                  </div>
              </div>
              <div className="column small-12 medium-8 large-5">
                {
                  this.state.isFetching
                  ?
                  <Loader/>
                  :
                  <form action="" onSubmit={this.handleSubmit}>

                      <FormElement label={this.state.labels.identity_doc}
                                   name="idNumber"
                                   type="text"
                                   required={true}
                                   value={this.state.idNumber}
                                   onChange={this.handleInputChange}/>

                      <FormElement label={this.state.labels.car_number}
                                   name="plateNumber"
                                   type="text"
                                   required={true}
                                   value={this.state.plateNumber}
                                   onChange={this.handleInputChange}/>


                      { this.error( this.state.error ) }

                      <div className="prop_search_submit text-center">
                          <Button inner={this.state.labels.button} classNames="btn-green" type="submit"/>
                      </div>

                  </form>
                }
              </div>
          </>

        )
    }
}
